export interface IProvider {
  id?: number;
  uuid?: string;
  name: string
  surname?: string
  document: string
  description?: string
  telephone?: string
  email?: string
  city?: string
  state?: string
  street_name?: string
  number?: string
  district?: string
  complement?: string
  zip_code?: string 
  address?:{
    city?: string,
    state?: string,
    street_name?: string,
    number?: string,
    district?: string,
    complement?: string,
    zip_code?: string 
    }
}


export const providerInitValues: IProvider = {
 //id: 0,
  name: '',
  surname: '',
  document: '',
  description: '',
  telephone: '',
  email: '',
  city: '',
  state: '',
  street_name: '',
  number: '',
  district: '',
  complement: '',
  zip_code: '',
  
}

